import {request2,request3} from "@/utils/request";


// 获取院校库
export const GetUniversityPlanPro = (data) => {
  return request2({
    method: "post",
    url: `/api/admissionstreds/university`,
    data,
  });
};

export const getUniversityTypes = () => {
  return request3({
    method: "get",
    url: `/api/v1/base/universitytype.json`,
    data:{
      staticType:"static"
    }
  });
}

export const getUniversityLevels = () => {
  return request3({
    method: "get",
    url: `api/v1/base/nature.json`,
    data:{
      staticType:"static"
    }
  });
}